/* Shared owner-approved Blackstone core PDP review behavior. */
(()=>{
 const root=document.querySelector('.fm-page:is([data-brand="Blackstone"],[data-brand="Broil King"])');if(!root)return;
 const template=document.querySelector('#aog-accordion-chevron');
 const enhance=()=>{
  if(template)root.querySelectorAll('details>summary:not([data-blackstone-chevron])').forEach(summary=>{summary.dataset.blackstoneChevron='true';if(!summary.querySelector(':scope > .ho-icon'))summary.append(template.content.cloneNode(true));});
  const actions=root.querySelector('.hx27-secondary-actions'),expert=root.querySelector('.fm-buy>a[href="/pages/customer-care#contact"]');
  if(actions&&expert)actions.append(expert);
 };
 enhance();new MutationObserver(enhance).observe(root,{childList:true,subtree:true});
 const videos=new Set();
 const visible=new Set();
 const start=video=>{
  if(!visible.has(video)||document.visibilityState!=='visible')return;
  video.muted=true;video.defaultMuted=true;video.playsInline=true;
  video.play().catch(()=>{});
 };
 const observer=new IntersectionObserver(entries=>{
  for(const entry of entries){
   const video=entry.target;
   if(entry.isIntersecting&&entry.intersectionRatio>0){visible.add(video);start(video);}
   else{visible.delete(video);video.pause();}
  }
 },{threshold:0});
 const register=()=>root.querySelectorAll('video:not([data-native-video-managed])').forEach(video=>{
  if(videos.has(video))return;videos.add(video);
  video.muted=true;video.defaultMuted=true;video.playsInline=true;
  video.setAttribute('muted','');video.setAttribute('playsinline','');
  video.preload='metadata';
  video.addEventListener('loadeddata',()=>start(video));
  video.addEventListener('canplay',()=>start(video));
  observer.observe(video);
 });
 register();new MutationObserver(register).observe(root,{childList:true,subtree:true});
 document.addEventListener('visibilitychange',()=>{
  for(const video of videos){if(document.hidden)video.pause();else start(video);}
 });
})();
